"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  title: {
    "id": "not-found-page.title",
    "defaultMessage": "Ooops! Page Not Found"
  },
  pageNotFound: {
    "id": "not-found-page.pageNotFound",
    "defaultMessage": "The requested page was not found. You can either return to the previous page, or visit the homepage or contact our support."
  },
  previousPage: {
    "id": "not-found-page.previousPage",
    "defaultMessage": "Previous page"
  },
  homepage: {
    "id": "not-found-page.homepage",
    "defaultMessage": "Homepage"
  }
});
exports.messages = messages;
//# sourceMappingURL=sb-not-found-page-i18n.js.map